module.exports = __webpack_public_path__ + "static/media/reminder-date.93589309.svg";